const baseColors = {
  black: '#000000',
  soft_black: '#222B45',
  white: '#FFFFFF',
  primary: '#C25CE6',
  primary_hover: '#a84ed6',
  primary_active: '#9340c0',
  secondary: '#FFFFFF80',
  gray: '#8F9BB3',
  text_gray: '#777777',
  text_dark: '#333333',
  soft_red: '#FF6161',
  error_red: '#FF4D4F',
  soft_green: '#4AFFA1',
  hot_green: '#37D15D',
  success_green: '#00D68F',
  soft_blue: '#2E9DFB',
  info_blue: '#1890FF',
  nature_green: '#49FF95',
  light_gray: '#F1F1F1',
  border_light: '#f0f0f0',
  background_gray: '#f9f9f9',
  dark: '#1C1B1F',
  dark_gray: '#C6C6C6',
};

const gradients = {
  primary_gradient: 'linear-gradient(90deg, #8049FF 0%, #A781FF 100%)',
  dark_gradient: 'linear-gradient(180deg, rgb(8, 8, 8) 0%, rgb(45, 45, 45) 100%)',
  radial_gradient_dark:
    'linear-gradient(0deg, #FFFFFF, #FFFFFF), radial-gradient(50% 50% at 50% 50%, #474747 0%, #000000 100%)',
  radial_gradient_black: 'linear-gradient(180deg, #080808 0%, #2D2D2D 100%)',
};

const opacity = {
  primary_opacity: 'rgba(128, 73, 255, 0.1)',
  black_opacity: '#00000080',
  black_opacity30: '#00000080',
  black_opacity50: '#00000080',
  white_opacity: '#FFFFFF80',
  white_opacity10: '#FFFFFF1A',
  gray_opacity: '#8F9BB380',
  green_opacity: '#4AFFA11A',
};

export const colors = { ...baseColors, ...gradients, ...opacity };
